import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  line-height: 110%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n\n  span {\n    color: #bfbfbf;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  z-index: 3;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  line-height: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  top: 0px;\n  z-index: 2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 672px;\n  max-width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef, useState, forwardRef } from 'react';
import styled from 'styled-components';
import Icon from '../../icon';
import { faSearch, faTimes, faSpinner } from '../../icon/sets/regular';
import Input, { changeInputValueByRef } from '../../shared/input';
import useAutocomplete from '../utils/useAutocomplete';
import Dropdown, { Option, convertChildrenToItems } from '../../dropdown';
import { legacySwappable, ThemeUnsupported } from '../../theme';
var Container = styled.div(_templateObject());

var noop = function noop(v) {
  return v;
};

var StyledInput = styled(Input)(_templateObject2());
var HiddenInput = styled.input(_templateObject3());
var SelectedItemLabel = styled.div(_templateObject4());
var TypingInput = styled.input(_templateObject5());
var DOMInputOverlay = styled.div(_templateObject6());
var DOMInputComponent = forwardRef(function (_ref, ref) {
  var suggestedOption = _ref.suggestedOption,
      name = _ref.name,
      className = _ref.className,
      typed = _ref.typed,
      onTypedChange = _ref.onTypedChange,
      onChange = _ref.onChange,
      selectedItem = _ref.selectedItem,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ["suggestedOption", "name", "className", "typed", "onTypedChange", "onChange", "selectedItem", "value"]);

  noop(value);
  var suggestion = suggestedOption && suggestedOption.label;

  var _map = [typed, suggestion].map(function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return str.toLowerCase();
  }),
      _map2 = _slicedToArray(_map, 2),
      typedLower = _map2[0],
      suggestionLower = _map2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DOMInputOverlay, {
    className: className
  }, typed, typed && suggestionLower.indexOf(typedLower) === 0 && /*#__PURE__*/React.createElement("span", null, suggestionLower.split(typed).slice(1).join(typed))), /*#__PURE__*/React.createElement(SelectedItemLabel, {
    className: className,
    id: "".concat(name, "-value-label")
  }, !typed && (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label)), /*#__PURE__*/React.createElement(TypingInput, _extends({}, other, {
    id: "".concat(name, "-typing"),
    ref: ref,
    className: className,
    value: typed || '',
    onChange: onTypedChange,
    "aria-labelledby": "".concat(name, "-value-label ").concat(name, "-label"),
    role: "button",
    tabIndex: 0,
    "aria-haspopup": "listbox",
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement(HiddenInput, _extends({
    name: name,
    className: className,
    onChange: onChange
  }, {
    value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || '',
    id: "".concat(name, "-value"),
    readOnly: true,
    tabIndex: -1,
    "aria-labelledby": "".concat(name, "-value-label ").concat(name, "-label")
  })));
});

var SearchInput = function SearchInput(_ref2) {
  var _ref2$availableOption = _ref2.availableOptions,
      availableOptions = _ref2$availableOption === void 0 ? [] : _ref2$availableOption,
      children = _ref2.children,
      leftIcon = _ref2.leftIcon,
      isLoading = _ref2.isLoading,
      propsSelectedItem = _ref2.value,
      propsSetSelectedItem = _ref2.onChange,
      propsTyped = _ref2.typed,
      propsOnTypedChange = _ref2.onTypedChange,
      inputProps = _objectWithoutProperties(_ref2, ["availableOptions", "children", "leftIcon", "isLoading", "value", "onChange", "typed", "onTypedChange"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      internalSelectedItem = _useState2[0],
      setInternalSelectedItem = _useState2[1];

  var selectedItem = propsSelectedItem || internalSelectedItem;

  var setSelectedItem = function setSelectedItem(item) {
    setInternalSelectedItem(item);
    if (propsSetSelectedItem) propsSetSelectedItem(item);
  };

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      internalTyped = _useState4[0],
      setInternalTyped = _useState4[1];

  var typed = propsTyped || internalTyped;

  var onTypedChange = propsOnTypedChange || function (e) {
    return setInternalTyped(e.target.value);
  };

  var boxRef = useRef();
  var inputRef = useRef();

  var _useAutocomplete = useAutocomplete({
    anchorRef: boxRef,
    availableOptions: availableOptions,
    results: children && convertChildrenToItems(children),
    onSelect: function onSelect(item) {
      if (inputRef.current) inputRef.current.blur();
      changeInputValueByRef(inputRef, '');
      setSelectedItem(item);
    },
    value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value,
    typed: typed
  }),
      onKeyDown = _useAutocomplete.onKeyDown,
      resultsShown = _useAutocomplete.resultsShown,
      results = _useAutocomplete.results,
      getItemProps = _useAutocomplete.getItemProps,
      listProps = _useAutocomplete.listProps,
      suggestedOption = _useAutocomplete.suggestedOption;

  var isExpanded = !!(resultsShown && results);
  var filteredChildren = children || results.map(function (r) {
    return /*#__PURE__*/React.createElement(Option, {
      key: r.value
    }, r.label);
  });
  return /*#__PURE__*/React.createElement(Container, {
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({}, inputProps, {
    selectedItem: selectedItem,
    typed: typed,
    onTypedChange: onTypedChange,
    suggestedOption: suggestedOption
  }, {
    inputRef: inputRef
  }, {
    value: typed || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value),
    allowLabelShrink: false,
    ref: boxRef,
    inputComponent: DOMInputComponent,
    rightIcon: /*#__PURE__*/React.createElement(Icon, {
      icon: faTimes,
      onClick: function onClick() {
        return setSelectedItem(null);
      }
    }),
    leftIcon: leftIcon || /*#__PURE__*/React.createElement(Icon, {
      icon: isLoading ? faSpinner : faSearch,
      spin: isLoading || false
    })
  })), /*#__PURE__*/React.createElement("span", {
    "aria-expanded": isExpanded
  }, isExpanded && /*#__PURE__*/React.createElement(Dropdown, _extends({
    name: inputProps.name
  }, {
    getItemProps: getItemProps,
    listProps: listProps
  }, {
    anchorRef: boxRef
  }), filteredChildren)));
};

export default legacySwappable(ThemeUnsupported, SearchInput);